import React from 'react';
import { Dropdown } from 'semantic-ui-react';

import { PagoEventual } from '../tipos';
import EliminarPagoEventual from './EliminarPagoEventual';

interface Props {
    idPlanDePago: string;
    pago: PagoEventual;
    alEditarPago(): void;
}

const AccionesTablaPagosEventuales: React.FunctionComponent<Props> = props => {
    const { pago, idPlanDePago, alEditarPago } = props;

    return (
        <Dropdown icon='ellipsis vertical' pointing='top right'>
            <Dropdown.Menu>
                <EliminarPagoEventual
                    idPlanDePago={idPlanDePago}
                    pago={pago}
                    alEditarPago={alEditarPago}
                />
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default AccionesTablaPagosEventuales;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Componentes/AccionesTablaPagosEventuales.tsx